import { makeStyles, Theme } from '@material-ui/core/styles';

const useStylesGrid = makeStyles((theme: Theme) => ({
    gridColumnHeader: {
        padding: `${theme.spacing(0.5, 1.5)} !important`,
        borderRight: '1px solid #fff !important',
        backgroundColor: '#0d273e',
        color: '#fff',
        '&.k-sorted': {
            borderRight: '1px solid #fff !important',
            backgroundColor: '#0d273e',
            color: theme.palette.grey[400],

            '& .k-icon': {
                color: theme.palette.grey[400],
            },
        },
        '& .k-link': {
            fontWeight: 'normal',
            '&:hover': {
                color: theme.palette.grey[400],
            },
        },
        '& [type="checkbox"]': {
            borderColor: 'white',
        },
    },
    gridColumn: {
        padding: `${theme.spacing(0.5, 1.5)} !important`,
        borderRightWidth: '1px !important',
        borderBottomWidth: '1px !important',
        fontSize: '12px',
        width: '100%',
        '&:last-child': {
            borderRightWidth: '1px !important',
            borderBottomWidth: '1px !important',
        },
        
    },
    gridColumnMultiInput: {
        '& .k-multiselect-wrap': {
            maxHeight:"15vh",
            overflowX:"auto"
        },
    },

    grid: {
        '& .k-grid-toolbar': {
            backgroundColor: theme.palette.primary.main,
            borderBottom: `1px solid ${theme.palette.grey[400]} !important`,
            padding: `${theme.spacing(0.5, 1.5)} !important`,
            height: '40px !important',
        },
        '& .k-grid-header': {
            backgroundColor: '#0d273e',
            borderBottom: `1px solid ${theme.palette.grey[400]} !important`,
            color: '#fff',
        },
        '& .k-master-row': {
            '&:nth-of-type(even)': {
                backgroundColor: theme.palette.action.hover,
            },

            '&.k-state-selected': {
                backgroundColor: '#8dd9c8',
            },
        },
    },
    gridSecurity: {
        '& .k-grid-container': {
            maxHeight: '71vh',
        },
    },
    gridSecurityGroups: {
        '& .k-grid-container': {
            maxHeight: '68vh',
        },
    },
    gridDataScopeSecurityGroups: {
        '& .k-grid-container': {
            maxHeight: '53vh',
        },
    },
}));

export default useStylesGrid;
